export class AzureAccountConfigInput {
    'tenantId';
    'applicationId';
    'resourceGroup';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tenantId",
            "baseName": "tenantId",
            "type": "string",
            "format": ""
        },
        {
            "name": "applicationId",
            "baseName": "applicationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceGroup",
            "baseName": "resourceGroup",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureAccountConfigInput.attributeTypeMap;
    }
    constructor() {
    }
}
